import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureAccessService } from './feature-access.service';

/**
 * UC-04 (#9281) route guard. Tenant enablement is controlled by the
 * `tblPage` row `PageName='MaverickSpend'` — the FE reads its Status via
 * the cached sidebar payload. Non-opted-in tenants get redirected to
 * /dashboard (the app's landing route).
 */
export const maverickSpendGuard: CanActivateFn = () => {
  const featureAccess = inject(FeatureAccessService);
  const router = inject(Router);
  if (featureAccess.isPageActive('maverick-spend')) {
    return true;
  }
  router.navigateByUrl('dashboard');
  return false;
};
